export type WorkType = 'movie' | 'tv';

interface Work {
  id: string;
  title: string;
  type: WorkType;
  year: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  popularity: number;
  cover: string;
  banner: string;
  summary: string;
  featured: boolean;
  episodes: number;
}

export const works: Work[] = [
  {
    id: 'w01',
    title: '云海之上',
    type: 'movie',
    year: 2025,
    region: '国产',
    genres: ['剧情', '冒险'],
    director: '韩振国',
    actors: ['林清言', '陈默', '周雨桐', '苏黎'],
    rating: 8.6,
    popularity: 96,
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20movie%20poster%20illustration%20of%20a%20lone%20hiker%20on%20a%20rocky%20summit%20above%20an%20endless%20sea%20of%20clouds%20at%20golden%20sunrise%2C%20warm%20orange%20glow%20blending%20into%20deep%20teal%20shadows%2C%20epic%20scale%2C%20minimal%20painterly%20composition%2C%20no%20text&width=600&height=900&seq=mxt-cover-w01-2026&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20landscape%20of%20a%20hiker%20standing%20on%20a%20mountain%20ridge%20above%20a%20vast%20sea%20of%20clouds%20at%20sunrise%2C%20warm%20orange%20light%20against%20deep%20teal%20mountain%20shadows%2C%20epic%20atmospheric%20painterly%20style%2C%20no%20text&width=1600&height=700&seq=mxt-banner-w01-2026&orientation=landscape',
    summary:
      '一位失去方向的高山向导，在攀登最后一座从未有人登顶的雪峰途中，重新找回了与家人、与自己的和解。云海翻涌之间，每一次呼吸都是对生命的确认。',
    featured: true,
    episodes: 0,
  },
  {
    id: 'w02',
    title: '星河追缉',
    type: 'movie',
    year: 2025,
    region: '欧美',
    genres: ['科幻', '动作'],
    director: 'Marcus Dell',
    actors: ['Ethan Cole', 'Nina Rhodes', 'David Park', 'Lara Ford'],
    rating: 8.2,
    popularity: 98,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20futuristic%20spacecraft%20chasing%20through%20a%20glowing%20nebula%2C%20bold%20orange%20thrusters%20against%20a%20deep%20navy%20starfield%2C%20high%20contrast%20sleek%20minimal%20design%2C%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=mxt-cover-w02-2026&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20chase%20scene%20with%20a%20sleek%20starship%20flying%20past%20a%20glowing%20orange%20nebula%20and%20dense%20starfield%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20cinematic%20wide%20composition%2C%20no%20text&width=1600&height=700&seq=mxt-banner-w02-2026&orientation=landscape',
    summary:
      '银河边境的赏金猎人接下最后一单追缉任务，却发现目标竟是自己失散多年的搭档。跨越三个星系的追逐，把两个人的信任推向了生死边缘。',
    featured: true,
    episodes: 0,
  },
  {
    id: 'w03',
    title: '午夜回声',
    type: 'movie',
    year: 2024,
    region: '欧美',
    genres: ['悬疑', '惊悚'],
    director: 'Julian Marsh',
    actors: ['Grace Hale', 'Owen Blake', 'Sophie Lane'],
    rating: 7.9,
    popularity: 84,
    cover: 'https://readdy.ai/api/search-image?query=Moody%20thriller%20movie%20poster%20of%20a%20dim%20rainy%20city%20street%20at%20midnight%20with%20a%20solitary%20silhouette%20under%20a%20streetlamp%2C%20cold%20teal%20tones%20with%20a%20warm%20amber%20light%2C%20cinematic%20noir%20mood%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=mxt-cover-w03-2026&orientation=portrait',
    banner: '',
    summary:
      '一名深夜电台主持人不断接到同一个陌生号码的来电，电话那头预告着一桩桩尚未发生的案件。当真凶的轮廓逐渐清晰，她才发现自己早已身在局中。',
    featured: false,
    episodes: 0,
  },
  {
    id: 'w04',
    title: '长安夜雨',
    type: 'tv',
    year: 2025,
    region: '国产',
    genres: ['古装', '权谋', '剧情'],
    director: '沈书白',
    actors: ['顾清越', '柳寒烟', '谢云舟', '裴敬'],
    rating: 8.8,
    popularity: 99,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20poster%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20night%20in%20the%20rain%2C%20warm%20lantern%20glow%20and%20deep%20crimson%20shadows%2C%20elegant%20classical%20composition%2C%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=mxt-cover-w04-2026&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Atmospheric%20wide%20view%20of%20an%20ancient%20Chinese%20imperial%20city%20under%20rainy%20night%20sky%2C%20rows%20of%20warm%20lanterns%20reflecting%20on%20wet%20stone%2C%20deep%20crimson%20and%20amber%20tones%2C%20cinematic%20historical%20drama%20mood%2C%20no%20text&width=1600&height=700&seq=mxt-banner-w04-2026&orientation=landscape',
    summary:
      '盛唐末年，一场落了一整夜的雨，改写了整座长安城。出身寒门的女官与两位皇子之间，家国、情义与权谋纠缠不休，每个人都在雨夜中做出了自己的选择。',
    featured: true,
    episodes: 46,
  },
  {
    id: 'w05',
    title: '东京咖啡馆的午后',
    type: 'tv',
    year: 2024,
    region: '日韩',
    genres: ['都市', '爱情', '治愈'],
    director: '佐藤悠介',
    actors: ['宫本夏树', '高桥凉介', '小林诗织'],
    rating: 8.0,
    popularity: 82,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20slice%20of%20life%20drama%20poster%20of%20a%20cozy%20Tokyo%20corner%20cafe%20in%20soft%20afternoon%20light%2C%20a%20coffee%20cup%20on%20a%20wooden%20table%20by%20a%20rainy%20window%2C%20gentle%20amber%20and%20cream%20tones%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=mxt-cover-w05-2026&orientation=portrait',
    banner: '',
    summary:
      '一间开在巷子深处的老咖啡馆，每天午后都会迎来形形色色的客人。店主用一杯手冲咖啡，静静接住每个人欲言又止的心事。',
    featured: false,
    episodes: 12,
  },
  {
    id: 'w06',
    title: '深海信号',
    type: 'movie',
    year: 2024,
    region: '国产',
    genres: ['科幻', '悬疑'],
    director: '方致远',
    actors: ['陆沉', '温如故', '韩九'],
    rating: 8.1,
    popularity: 88,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20thriller%20poster%20of%20a%20deep%20sea%20research%20submarine%20descending%20into%20dark%20ocean%20depths%20with%20a%20faint%20glowing%20signal%20in%20the%20distance%2C%20teal%20and%20orange%20contrast%2C%20mysterious%20mood%2C%20no%20text&width=600&height=900&seq=mxt-cover-w06-2026&orientation=portrait',
    banner: '',
    summary:
      '万米海沟之下，一艘科考潜艇捕捉到一段无法解释的重复信号。当船员们循着信号继续下潜，他们面对的或许是人类不该触碰的答案。',
    featured: false,
    episodes: 0,
  },
  {
    id: 'w07',
    title: '野径花开',
    type: 'movie',
    year: 2023,
    region: '国产',
    genres: ['剧情', '家庭'],
    director: '许知微',
    actors: ['何秀兰', '林小满', '赵望山'],
    rating: 8.4,
    popularity: 76,
    cover: 'https://readdy.ai/api/search-image?query=Gentle%20family%20drama%20movie%20poster%20of%20a%20winding%20countryside%20path%20lined%20with%20wildflowers%20in%20spring%20sunshine%2C%20soft%20warm%20palette%2C%20painterly%20rural%20landscape%2C%20hopeful%20mood%2C%20no%20text&width=600&height=900&seq=mxt-cover-w07-2026&orientation=portrait',
    banner: '',
    summary:
      '山村教师退休后回到故乡，决定把废弃多年的小学重新办起来。一群留守孩子和一位倔强的老人，在一条开满野花的山路上，慢慢长出了新的希望。',
    featured: false,
    episodes: 0,
  },
  {
    id: 'w08',
    title: '末日黎明',
    type: 'tv',
    year: 2025,
    region: '欧美',
    genres: ['科幻', '末日', '冒险'],
    director: 'Hannah Reeves',
    actors: ['Caleb Stone', 'Iris Nakamura', 'Tom Vega', 'Mia Frost'],
    rating: 8.5,
    popularity: 94,
    cover: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci-fi%20series%20poster%20of%20a%20lone%20survivor%20walking%20across%20a%20cracked%20desert%20wasteland%20toward%20a%20rising%20orange%20sun%2C%20dust%20haze%2C%20dramatic%20wide%20composition%2C%20no%20text&width=600&height=900&seq=mxt-cover-w08-2026&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Vast%20post%20apocalyptic%20wasteland%20at%20dawn%20with%20ruined%20skyscrapers%20silhouetted%20against%20a%20huge%20orange%20sun%2C%20dust%20and%20haze%2C%20lone%20traveler%20in%20the%20distance%2C%20cinematic%20scale%2C%20no%20text&width=1600&height=700&seq=mxt-banner-w08-2026&orientation=landscape',
    summary:
      '文明崩塌后的第十年，一支由幸存者组成的队伍穿越废土，寻找传说中仍有人类聚居的绿洲。真正的敌人，从来不是荒野，而是人心。',
    featured: true,
    episodes: 24,
  },
  {
    id: 'w09',
    title: '琉璃色的夏天',
    type: 'tv',
    year: 2023,
    region: '日韩',
    genres: ['青春', '校园', '爱情'],
    director: '中村葵',
    actors: ['山崎美咲', '佐久间悠', '铃木葵'],
    rating: 7.8,
    popularity: 79,
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20youth%20drama%20poster%20of%20two%20students%20on%20a%20seaside%20school%20rooftop%20in%20summer%2C%20vivid%20blue%20sky%20and%20warm%20sunlight%2C%20soft%20film%20grain%2C%20romantic%20coming%20of%20age%20mood%2C%20no%20text&width=600&height=900&seq=mxt-cover-w09-2026&orientation=portrait',
    banner: '',
    summary:
      '高中最后一个夏天，转学生与摄影社社长因为一卷没冲洗完的胶片相识。多年后当他们再回到那间天台，才发现那年夏天从未真正结束。',
    featured: false,
    episodes: 16,
  },
  {
    id: 'w10',
    title: '铁血长城',
    type: 'movie',
    year: 2024,
    region: '国产',
    genres: ['战争', '历史'],
    director: '郑铁军',
    actors: ['雷震', '秦川', '宋怀民', '白薇'],
    rating: 8.3,
    popularity: 90,
    cover: 'https://readdy.ai/api/search-image?query=Epic%20war%20film%20poster%20of%20soldiers%20standing%20on%20an%20ancient%20stone%20fortress%20wall%20at%20dawn%20under%20a%20burning%20sky%2C%20dust%20and%20flame%2C%20heroic%20dramatic%20lighting%2C%20warm%20orange%20and%20deep%20brown%20tones%2C%20no%20text&width=600&height=900&seq=mxt-cover-w10-2026&orientation=portrait',
    banner: '',
    summary:
      '一场决定命运的守城战里，一支被历史遗忘的边军小队，用七天七夜守住了身后的万家灯火。他们没能留下姓名，却成了真正的长城。',
    featured: false,
    episodes: 0,
  },
  {
    id: 'w11',
    title: '迷雾庄园',
    type: 'tv',
    year: 2024,
    region: '欧美',
    genres: ['悬疑', '犯罪'],
    director: 'Elliot Grant',
    actors: ['Amelia Bright', 'Hugo Sinclair', 'Rose Adler'],
    rating: 8.1,
    popularity: 86,
    cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20series%20poster%20of%20a%20grand%20old%20manor%20house%20shrouded%20in%20thick%20fog%20at%20dusk%2C%20single%20lit%20window%2C%20muted%20gray%20and%20amber%20tones%2C%20suspenseful%20mood%2C%20no%20text&width=600&height=900&seq=mxt-cover-w11-2026&orientation=portrait',
    banner: '',
    summary:
      '一座被浓雾终年笼罩的庄园，一位刚刚继承遗产的年轻继承人，和一封写着十年前命案真相的匿名信。所有人都说着真话，只是没人说出全部。',
    featured: false,
    episodes: 8,
  },
  {
    id: 'w12',
    title: '山城往事',
    type: 'tv',
    year: 2022,
    region: '国产',
    genres: ['年代', '剧情'],
    director: '陈守拙',
    actors: ['刘建国', '罗玉梅', '甘小虎', '周晓'],
    rating: 8.7,
    popularity: 74,
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20poster%20of%20a%20hillside%20town%20with%20layered%20old%20buildings%20and%20stone%20stairways%20in%20warm%20evening%20light%2C%20sepia%20and%20amber%20tones%2C%20poetic%20community%20mood%2C%20no%20text&width=600&height=900&seq=mxt-cover-w12-2026&orientation=portrait',
    banner: '',
    summary:
      '从上世纪八十年代开始，一条蜿蜒的石梯串起了山城三户人家近四十年的悲欢。时代在变，人情与烟火气却始终留在那条石梯上。',
    featured: false,
    episodes: 30,
  },
  {
    id: 'w13',
    title: '极地之光',
    type: 'movie',
    year: 2025,
    region: '欧美',
    genres: ['冒险', '剧情'],
    director: 'Ingrid Solberg',
    actors: ['Oliver Lund', 'Freya Nilsen', 'Karl Aas'],
    rating: 8.6,
    popularity: 92,
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20of%20an%20explorer%20on%20a%20glacier%20beneath%20green%20and%20violet%20aurora%20in%20a%20polar%20night%20sky%2C%20vast%20icy%20landscape%2C%20awe%20inspiring%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=mxt-cover-w13-2026&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20polar%20landscape%20of%20a%20lone%20explorer%20crossing%20a%20frozen%20glacier%20under%20shimmering%20green%20and%20violet%20aurora%20at%20night%2C%20vast%20icy%20horizon%2C%20cinematic%20awe%20inspiring%20mood%2C%20no%20text&width=1600&height=700&seq=mxt-banner-w13-2026&orientation=landscape',
    summary:
      '一支极地科考队为寻找失踪的队员深入冰原，在极夜与极光的交替中，他们必须决定：是继续寻找，还是带着真相与遗憾活着回去。',
    featured: true,
    episodes: 0,
  },
  {
    id: 'w14',
    title: '微微一笑的时光',
    type: 'tv',
    year: 2025,
    region: '国产',
    genres: ['都市', '爱情', '轻喜剧'],
    director: '叶南舟',
    actors: ['沈知意', '江辞', '宁欢', '温言'],
    rating: 7.6,
    popularity: 89,
    cover: 'https://readdy.ai/api/search-image?query=Bright%20modern%20romance%20drama%20poster%20of%20a%20young%20couple%20sharing%20a%20laugh%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20orange%20sky%2C%20soft%20bokeh%20city%20lights%2C%20cheerful%20mood%2C%20no%20text&width=600&height=900&seq=mxt-cover-w14-2026&orientation=portrait',
    banner: '',
    summary:
      '一位严谨的建筑师和一位随性的甜品师，因为一次外卖送错而认识。两个生活节奏完全不同的人，在一场场误会里慢慢走近，也慢慢学会为自己而活。',
    featured: false,
    episodes: 32,
  },
];

export const FEATURED_TITLES = ['云海之上', '星河追缉', '长安夜雨', '末日黎明', '极地之光'];